import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineMoonIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21.64 13a.9994.9994 0 0 0-1.05-.14 8.0501 8.0501 0 0 1-3.37.73 8.15 8.15 0 0 1-8.14-8.1 8.59 8.59 0 0 1 .25-2A1 1 0 0 0 8 2.36a10.14 10.14 0 1 0 14 11.69 1.0006 1.0006 0 0 0-.36-1.05Zm-9.5 6.69A8.1399 8.1399 0 0 1 7.08 5.22v.27a10.1498 10.1498 0 0 0 10.14 10.14 9.7908 9.7908 0 0 0 2.1-.22 8.11 8.11 0 0 1-7.18 4.32v-.04Z"/>
  </SvgIcon>
}

export default LineMoonIcon
